<router-outlet></router-outlet>


// WEBPACK FOOTER //
// ./src/app/admin/assessment-admin/assessment-admin.component.html